"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebClientResponseHelper = void 0;
var WebClientResponseHelper;
(function (WebClientResponseHelper) {
    function isErrorResponse(response) {
        return !!response.error;
    }
    WebClientResponseHelper.isErrorResponse = isErrorResponse;
    function failErrorResponse(response) {
        return isErrorResponse(response) ? Promise.reject(response) : Promise.resolve(response);
    }
    WebClientResponseHelper.failErrorResponse = failErrorResponse;
})(WebClientResponseHelper = exports.WebClientResponseHelper || (exports.WebClientResponseHelper = {}));
//# sourceMappingURL=webClientResponse.js.map